module.exports = __webpack_public_path__ + "static/img/IMG_20160224_140115.d26c29ab.jpg";